import { LockOpenAlertOutlineIcon } from './LockOpenAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 47EFC7F8-698E-4466-8EDE-DB6334FE6C18
 * name lock-open-alert-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 * - Lock 
 */
export const UnlockedWarningOutlineIcon = LockOpenAlertOutlineIcon;
export default UnlockedWarningOutlineIcon